import React from 'react';
import {
  Box,
  Typography,
  Modal,
  Button,
} from '@mui/material';

function TooltipModal({ open, handleClose, transactionDetails }) {

  if (!transactionDetails) return null; // Prevent rendering if no data

  const formatDateString = (dateStr) => {
    if (!dateStr) return "N/A";
    const dt = new Date(dateStr);
    return dt.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="wallet-details-modal-title"
      aria-describedby="wallet-details-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '70%', sm: '400px' },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '8px',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            mb: 2,
          }}
        >
          <Typography
            id="wallet-details-modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '2.5rem', sm: '2rem' }, // mobile 20px, desktop 24px approx
            }}
          >
            Transaction Details
          </Typography>

          {/* {transactionDetails.rewardType && (
            <Typography
              sx={{
                textAlign: 'right',
                fontSize: { xs: '2rem', sm: '2rem' }, // mobile ~11px, desktop ~13px
                backgroundColor: '#1669F2',
                color: '#FFFFFF',
                p: 0.5,
                borderRadius: '10px',
                fontWeight: '500',
                display: 'inline-block',
                textTransform: 'uppercase',
              }}
            >
              {transactionDetails.rewardType.replace(/_/g, ' ')}
            </Typography>
          )} */}
        </Box>

        {/* <Typography sx={{ mb: 1, fontSize: { xs: '0.85rem', sm: '1rem' } }}>
          <strong>Transaction Type:</strong> {transactionDetails.type || "N/A"}
        </Typography> */}

        <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem' } }}>
          <strong>Project Name:</strong> {transactionDetails.projectName || "N/A"}
        </Typography>

        <Typography sx={{ mb: 1, fontSize: {xs: '2rem', sm: '2rem' } }}>
          <strong>Wing Name:</strong> {transactionDetails.wing || "N/A"}
        </Typography>

        <Typography sx={{ mb: 1, fontSize: {xs: '2rem', sm: '2rem' } }}>
          <strong>Unit Number:</strong> {transactionDetails.unitId || "N/A"}
        </Typography>

        {transactionDetails.payeeVA && (
          <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem'  } }}>
            <strong>Payee Virtual Account:</strong> {transactionDetails.payeeVA}
          </Typography>
        )}

        {/* {transactionDetails.payeeName && (
          <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem'  } }}>
            <strong>Payee Name:</strong> {transactionDetails.payeeName}
          </Typography>
        )} */}

        {transactionDetails.description && (
          <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem' } }}>
            <strong>Description:</strong> {transactionDetails.description}
          </Typography>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button
            onClick={handleClose}
            sx={{
              backgroundColor: '#1669f2',
              color: '#FFFFFF',
              textTransform: 'none',
              fontSize: { xs: '2rem', sm: '1.5rem' },
              '&:hover': { backgroundColor: '#1257cc' },
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default TooltipModal;
